import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianAvailabilityCalendar } from 'types';

type getTechnicianAvailabilityCalendarParams = {
  technicianId?: string;
  month: number;
  year: number;
};

export const getTechnicianAvailabilityCalendar = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianAvailabilityCalendarParams]>): Promise<TechnicianAvailabilityCalendar> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(
    `technicians/${params.technicianId}/availability-calendar?month=${params.month}&year=${params.year}`,
  );

  return data as TechnicianAvailabilityCalendar;
};
